/**
 * Used to call the Listrak Service for page browse
 */

module.exports = {
    listrackProductTracking: function (skuData, d) {
        if (document.addEventListener) document.addEventListener('ltkAsyncListener', d);
        else {
            e = document.documentElement; e.ltkAsyncProperty = 0; e.attachEvent('onpropertychange', function (e) {
                if (e.propertyName === 'ltkAsyncProperty') { d(); }
            });
        }
        /**
        * Used to reset the activity tracker parameters in the pdict upon successful send up to Listrak endpoint.
        */
        function resetProductActivityParams() {
            var path = clearUrl;
            jQuery.ajax({
                url: path,
                context: document,
                success: function () { }
            });
        }
        var scriptVars = document.querySelector('script[src*="ltkActivityTracking.js"]');

        var sku = skuData;
        var qvSku = scriptVars ? scriptVars.getAttribute('ltk-data-qvsku') : '';
        var category = scriptVars ? scriptVars.getAttribute('ltk-data-category') : '';
        var clearUrl = scriptVars ? scriptVars.getAttribute('ltk-data-clearurl') : '';
        //Custom Start:[MSS-1450] Get data attributes from isml
        var ltkCountryCode = scriptVars ? scriptVars.getAttribute('ltk-data-countryCode') : '';
        var ltkProductPrice = scriptVars ? scriptVars.getAttribute('ltk-data-price') : '';
        //Custom End:
        try {
            /* Perform activity/page/product browse logging. */
            var sessionSku = sku;
            var sessionCategory = category;
            var sessionQuickViewSkus = qvSku;

            /* Iterate through any quickviews and add them as product browses. */
            if (sessionQuickViewSkus != null && sessionQuickViewSkus !== 'null' && sessionQuickViewSkus.length > 0)		{
                var quickViews = sessionQuickViewSkus.split(',');

                for (var i = 0; i < quickViews.length; i++)			{
                    _ltk.Activity.AddProductBrowse(quickViews[i], { region: ltkCountryCode, localprice: ltkProductPrice });
                }
            }

            /* Add the product browse if we have it. */
            if (sessionSku != null && sessionSku !== 'null' && sessionSku.length > 0)		{
                _ltk.Activity.AddProductBrowse(sessionSku, { region: ltkCountryCode, localprice: ltkProductPrice });
            }

            /* Add the page browse. We should ALWAYS have if this JS fires. */
            var currentPage = window.location.href;
            _ltk.Activity.AddPageBrowse(currentPage, { region: ltkCountryCode });

            /* Submit the activity through client side JS to the endpoint. */
            _ltk.Activity.Submit();

            /* Do a post to reset the browse/quickview/page parameters if there are products in them. */
            resetProductActivityParams();
        }	catch (er)	{
            /* An error has occurred, yet to determine if we want to do anything here. */
        }
    }
}
